import { render, staticRenderFns } from "./OrderItemMenuProductList.vue?vue&type=template&id=d0253942&scoped=true&"
import script from "./OrderItemMenuProductList.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuProductList.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuProductList.vue?vue&type=style&index=0&id=d0253942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0253942",
  null
  
)

export default component.exports